import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="Footer">
      <div className="Footer-container">
        <div className="Footer-section">
          <p className="Footer-header">Address</p>
          <p>Survey #064<br/>
            Building #9, 13th Floor<br/>
            Email: sales@collabtechniqs.com<br/>
            Phone: +91 9676929286
          </p>
          <ul className="Footer-socials">
            <li>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
            </li>
            <li>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </li>
            <li>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </li>
          </ul>
        </div>
        <div className="Footer-section Footer-location">
          <p className="Footer-header">Our Location</p>
          <div className="Footer-map">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.413195061499!2d78.3803413!3d17.4399266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93f9c691c8cd%3A0xe7fd5d3a7259e65b!2sCOLLABTECHNIQS%20CONSULTING%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1745931588364!5m2!1sen!2sin"
              width="300"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
        <div className="Footer-section Footer-dunsSection">
          <p className="Footer-header">D&B Certification</p>
          <div className="Footer-duns">
            <iframe
              id="Iframe1"
              title="D&B Seal"
              src="https://dunsregistered.dnb.com/SealAuthentication.aspx?Cid=1"
              width="114"
              height="97"
              frameBorder="0"
              scrolling="no"
              style={{ border: 'none' }}
            ></iframe>
          </div>
        </div>
      </div>
        <div className="Footer-bottom">
          <p>© {currentYear} copyright all right reserved</p>
        </div>  
    </footer>
  );
}

export default Footer;